import { ApprovalVerdictItemModel } from 'api-hooks/approval-item';
import stylesColors from 'common/styles/styles.colors';
import { capitalize } from 'common/utils/string';
import { TableComponent } from 'components/elements';
import { IColumn } from 'components/elements/table-component/table-component';
import { format } from 'date-fns';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  approvalVerdicts: ApprovalVerdictItemModel[];
}

export default function ApprovalVerdictTable(props: Props) {
  const { t } = useTranslation();
  const { approvalVerdicts } = props;

  const columns = React.useMemo<IColumn<ApprovalVerdictItemModel>[]>(
    () => [
      {
        header: '#',
        accessorKey: 'index',
        minSize: 60,
        size: 60,
        cell: ({ row }) => row.index + 1,
      },
      {
        header: t('common:role'),
        accessorKey: 'role.name',
        minSize: 150,
      },
      {
        header: t('common:status'),
        accessorKey: 'status',
        minSize: 150,
        cell: ({ getValue }) => capitalize(getValue() as string),
      },
      {
        header: t('common:employee'),
        accessorKey: 'employee',
        minSize: 150,
        cell: ({ row }) => {
          const { original } = row;
          if (original.approvedBy) {
            return original.approvedBy.name;
          }
          if (original.rejectedBy) {
            return original.rejectedBy.name;
          }
          return '-';
        },
      },
      {
        header: t('common:date_of_approval'),
        accessorKey: 'date',
        minSize: 160,
        cell: ({ row }) => {
          const {
            original: { approvedAt, rejectedAt },
          } = row;
          const date = approvedAt || rejectedAt;
          return date ? format(date, 'dd MMM yyyy, HH:mm:ss') : '-';
        },
      },
    ],
    [t],
  );

  return (
    <TableComponent
      headerColor={stylesColors.bg1}
      data={approvalVerdicts}
      columns={columns}
    />
  );
}
